var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEbay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#f44336",
    d: "M6,19c-6.002-0.001-6.029,4.529-5.998,5.704c0,0-0.294,5.296,6.058,5.296c5.458,0,5.726-3.323,5.726-3.323l-2.51,0.005c0,0-0.489,1.831-3.205,1.781C2.579,28.4,2.443,25,2.443,25H12C12,24.999,12.643,19.001,6,19z M2.523,23.515c0,0,0.172-2.965,3.624-2.966c3.44-0.001,3.44,2.966,3.44,2.966H2.523z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#1976d2",
    d: "M18.825,19c-3.058-0.017-4.374,1.719-4.374,1.719V15H12v15h2.316l0.102-1.735c0,0,1.111,1.735,4.356,1.735c3.246,0,5.809-1.898,5.878-5.416C24.719,21.064,21.884,19.016,18.825,19z M18.264,28.431c-3.862,0.046-3.799-3.888-3.799-3.888s-0.141-3.873,3.793-3.97c3.933-0.097,3.875,4.051,3.875,4.051S22.126,28.384,18.264,28.431z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#8bc34a",
    d: "M34.437 19L37.243 19 41.349 27.185 45.463 19 48 19 40.573 34 37.859 34 40.009 29.537z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffc107",
    d: "M30.724,19.017c0,0-4.883-0.416-5.544,2.983h2.588c0.132-0.415,0.674-1.469,2.785-1.431c2.484,0.044,2.937,1.003,2.923,2.431c0,0-2.129,0.006-2.84,0.009c-1.28,0.006-5.761,0.345-6.179,2.945c-0.498,3.093,2.399,4.058,4.666,4.045c2.266-0.012,3.559-0.659,4.52-1.818l0.103,1.83L36,30v-6.805C35.936,22.032,36,19.224,30.724,19.017z M29.546,28.511c0,0-2.456,0.003-2.6-1.867c-0.154-1.996,3.778-2.078,3.778-2.078l2.778-0.003C33.501,24.564,33.951,28.567,29.546,28.511z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEbay);
export default __webpack_public_path__ + "static/media/ebay.8d02c6606666a114d7f3d0e2f50ddc18.svg";
export { ForwardRef as ReactComponent };